// extracted by mini-css-extract-plugin
export default {"row":"NavBar_row__IHOm1","NavBar":"NavBar_NavBar__NPiq6","activeLink":"NavBar_activeLink__INLvc","dormantLink":"NavBar_dormantLink__PrK1-"};